var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScrollIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Scroll Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 23,
    cy: 22.5,
    r: 21.5,
    transform: "rotate(90 23 22.5)",
    stroke: "#999999",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Arrow 1",
    d: "M8.79338 21.7929C8.40286 22.1834 8.40286 22.8166 8.79338 23.2071L15.1573 29.5711C15.5479 29.9616 16.181 29.9616 16.5716 29.5711C16.9621 29.1805 16.9621 28.5474 16.5716 28.1569L10.9147 22.5L16.5716 16.8431C16.9621 16.4526 16.9621 15.8195 16.5716 15.4289C16.181 15.0384 15.5479 15.0384 15.1573 15.4289L8.79338 21.7929ZM38.0005 21.5L9.50049 21.5L9.50049 23.5L38.0005 23.5L38.0005 21.5Z",
    fill: "#999999"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollIcon);
export default __webpack_public_path__ + "static/media/Scroll Icon.50e7f747e740d9abcb4b322c302d5b3e.svg";
export { ForwardRef as ReactComponent };